import { Box, Skeleton, Stack } from '@mui/material';

function LoadingSkeleton() {
  return (
    <Box sx={{ height: '100vh', width: '100vw' }}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        gap={2}
        sx={{ height: 'calc(100% - 32px)', p: 2 }}
      >
        <Skeleton
          variant="rounded"
          sx={{
            backgroundColor: 'grey.700',
            width: { xs: '100%', md: '45%', lg: '62%' },
            height: { xs: '30%', md: '100%' }
          }}
        />
        <Stack
          gap={2}
          sx={{
            width: { xs: '100%', md: '55%', lg: '38%' },
            height: { xs: '70%', md: '100%' }
          }}
        >
          <Skeleton
            variant="rounded"
            height="10%"
            sx={{
              backgroundColor: 'grey.400'
            }}
          />
          <Skeleton
            variant="rounded"
            height="5%"
            sx={{
              backgroundColor: 'grey.400'
            }}
          />
          <Skeleton
            variant="rounded"
            height="40%"
            sx={{
              backgroundColor: 'grey.400'
            }}
          />
          <Skeleton
            variant="rounded"
            height="5%"
            sx={{
              backgroundColor: 'grey.400'
            }}
          />
          <Skeleton
            variant="rounded"
            height="40%"
            sx={{
              backgroundColor: 'grey.400'
            }}
          />
        </Stack>
      </Stack>
    </Box>
  );
}

export default LoadingSkeleton;
